'use client'

import { useEffect } from 'react'

export default function HashScroller() {
  /*
   * Next might not have yet put any content on the page due to suspense or something else.
   * This might interrupt the default # anchor link behavior, so this component will pick up the
   * slack afterward and replicate the behavior.
   */
  useEffect(() => {
    const hash = window.location.hash.split('?')[0]
    if (!hash) return

    // Small delay to ensure DOM has painted after streaming
    requestAnimationFrame(() => {
      try {
        const el = document.querySelector(hash)
        el?.scrollIntoView({ behavior: 'smooth' })
      } catch (e) {
        console.warn(`[HashScroller] Could not find anchor for "${hash}"`, e)
      }
    })
  }, [])

  return null
}
